import faqData from './faq.json';
export interface FaqItem { q: string; a: string; }
export const faqByRoute = faqData as Record<string, FaqItem[]>;
export const normalizeFaqRoute = (pathname: string): string => pathname === '/' ? '/' : `/${pathname.replace(/^\/+|\/+$/g, '')}`;
export const getFaqForRoute = (pathname: string): FaqItem[] => faqByRoute[normalizeFaqRoute(pathname)] ?? [];
